import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../hooks/useLanguage';
import './NowSection.css';

export default function NowSection() {
  const { t } = useLanguage();

  return (
    <section className="now-section">
      <div className="now-inner">
        <h1 className="now-page-title">{t.now.title}</h1>
        <p className="now-intro">{t.now.intro}</p>
        <ul className="now-list">
          <li>{t.now.p1}</li>
          <li>{t.now.p2}</li>
          <li>{t.now.p3}</li>
        </ul>
        <p className="now-back">
          <Link to="/">{t.now.backHome}</Link>
        </p>
      </div>
    </section>
  );
}
